import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { deleteNextActions } from "@/modules/lead-page/api/lead-page.api";
import { toast } from "react-toastify";

const useDeleteNextAction = () => {
  const [dialogOpenConfirm, setDialogOpenConfirm] = useState(false);
  const [nextActionId, setNextActionId] = useState<
    string | number | undefined
  >();

  const deleteNextActionMutation = useMutation(
    (next_action_id: string | number | undefined) =>
      deleteNextActions(next_action_id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["getNextActions"] });
        toast.success("Next Action Done", {
          position: "bottom-left",
          autoClose: 2000,
        });
      },
      onError: (error: any) => {
        toast.error(
          error.status == 403
            ? "You are not authorized to complete this next action"
            : "Error to Complete Next Action",
          {
            position: "bottom-left",
            autoClose: 2000,
          }
        );
      },
    }
  );

  const handleDeleteNextAction = (
    next_action_id: string | number | undefined
  ) => {
    deleteNextActionMutation.mutate(next_action_id);
    setDialogOpenConfirm(false);
  };

  const handleDeleteDialog = (next_action_id: string | number | undefined) => {
    setNextActionId(next_action_id);
    setDialogOpenConfirm(true);
  };

  return {
    nextActionId,
    setNextActionId,
    handleDeleteNextAction,
    handleDeleteDialog,
    setDialogOpenConfirm,
    deleteNextActionMutation,
    dialogOpenConfirm,
    errorDeleting: deleteNextActionMutation.isError,
    successDeleting: deleteNextActionMutation.isSuccess,
    loadDeleting: deleteNextActionMutation.isLoading,
  };
};

export default useDeleteNextAction;
